import React, { useEffect, useState } from 'react';
import './CardContainer.css';
import HRMSCard from '../HRMSCard/HRMSCard';
import axios from 'axios';
import { HRMS_API_URL, HRMS_ORG_ID } from '../../config';

export default function CardContainer() {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleJobs = async () => {
        try {
            setLoading(true);
            setError(null);

            const params = {};
            const headers = {};

            if (HRMS_ORG_ID) {
                params.orgId = HRMS_ORG_ID;
                params.org_id = HRMS_ORG_ID;
                headers['x-org-id'] = HRMS_ORG_ID;
            }

            console.log("Fetching jobs from HRMS:", { url: `${HRMS_API_URL}/jobs`, params, headers });

            const response = await axios.get(`${HRMS_API_URL}/jobs`, { 
                params, 
                headers,
                timeout: 10000 
            });
            
            if (response.data && response.data.success && Array.isArray(response.data.jobs)) {
                setJobs(response.data.jobs);
            } else if (response.data && Array.isArray(response.data.data)) {
                setJobs(response.data.data);
            } else {
                setError("Unable to load current openings. Please try again later.");
            }
        } catch (err) {
            console.error("Error fetching jobs from HRMS API:", err.message);
            setError("Unable to load current openings. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleJobs();
    }, []);

    if (loading) {
        return (
            <div className="cardContainer__container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                <p style={{ fontSize: '18px', fontWeight: 'bold' }}>Loading current openings...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="cardContainer__container">
                <div className="cardContainer__sub__container">
                    <h3 className="heading">Current Openings</h3>
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                        <p style={{ color: 'red', fontSize: '16px', fontWeight: '600' }}>{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cardContainer__container">
            <div className="cardContainer__sub__container">
                <h3 className="heading">Current Openings</h3>
                <p className='subheading'>
                    We are searching for new talents and require a high level of creativity, honesty, and efficiency. We provide opportunities to people who are passionate, dynamic, and accountable in their work and have the ability to submit his/her given tasks on time.
                    This is the appropriate place for you if you have these skills and love to work in a fast-growing and technological environment. We would love to welcome you to our workplace.
                </p>

                <div className="cardContainer__Cards">
                    {jobs.length > 0 ? (
                        jobs.map((job) => (
                            <HRMSCard
                                key={job.id || job.job_id || job._id}
                                id={job.id || job.job_id || job._id}
                                heading={job.title}
                                category={job.category}
                                type={job.employmentType || job.type}
                                location={job.location}
                                experience={job.experience}
                                description={job.description}
                            />
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px 0' }}>
                            <p style={{ color: '#666', fontSize: '16px' }}>Currently, there are no open positions available. Please check back soon!</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
